import { Tooltip, TooltipProps } from '@mui/material';

//
//

type AppTooltipProps = TooltipProps & {};

//

export const AppTooltip: React.FC<AppTooltipProps> = (props) => {
  // enterTouchDelay: The number of milliseconds a user must touch the element before showing the tooltip
  return <Tooltip enterTouchDelay={0} {...props} />;
};
